import { ComponentSettings, FieldTypes } from "../settings/settings";

export const abbreviatedMonths: any = {
  january: { text: { de: "Jan", en: "Jan" } },
  february: { text: { de: "Feb", en: "Feb" } },
  march: { text: { de: "März", en: "Mar" } },
  april: { text: { de: "Apr", en: "Apr" } },
  may: { text: { de: "Mai", en: "May" } },
  june: { text: { de: "Jun", en: "Jun" } },
  july: { text: { de: "Jul", en: "Jul" } },
  august: { text: { de: "Aug", en: "Aug" } },
  september: { text: { de: "Sep", en: "Sep" } },
  october: { text: { de: "Okt", en: "Oct" } },
  november: { text: { de: "Nov", en: "Nov" } },
  december: { text: { de: "Dez", en: "Dec" } },
};

export const closedNewOptions: any = {
  new: { text: { de: "Neu", en: "New", nl: "Nieuw" } },
  closed: { text: { de: "Geschlossen", en: "Closed", nl: "Afgesloten" } },
  backlog: { text: { de: "Backlog", en: "Backlog", nl: "Backlog" } },
};

const settings = {
  permission: {
    viewDashboard: false,
  },
  text: {
    dashboard: {
      de: "Dashboard",
      en: "Dashboard",
      nl: "Dashboard",
    },
    statusByMPNTitle: {
      de: "Herstellerteilenummer nach Status",
      en: "Manufacturer Part Number according to status",
      nl: "Fabrikant Artikel Nummer volgens status",
    },
    statusByCPNTitle: {
      de: "Kundenteilenummer nach Status",
      en: "Customer Part Number according to status",
      nl: "Artikel Nummer volgens status",
    },
    reachByMPNTitle: {
      de: "Herstellerteilenummer enthält SVHC's (REACH)",
      en: "Manufacturer Part Number contains SVHC's (REACH)",
      nl: "Fabrikant Artikel Nummer bevat SVHC's (REACH)",
    },
    reachByCPNTitle: {
      de: "Kundenteilenummer enthält SVHC's (REACH)",
      en: "Customer Part Number contains SVHC's (REACH)",
      nl: "Artikel Nummer bevat SVHC's (REACH)",
    },
    statusByOMFTitle: {
      de: "Fälle nach Status",
      en: "Cases according to status",
      nl: "Issues per status",
    },
    statusByMonthTitle: {
      de: "Neue/Abgeschlossene Fälle",
      en: "New/Closed Cases",
      nl: "Nieuwe/Afgesloten Issues",
    },
    statusByMonthSubtitle: {
      de: "Fälle insgesamt: ",
      en: "Total Cases: ",
      nl: "Totaal zaken: ",
    },
    tasksCreatedAndClosedTitle: {
      de: "Im aktuellen Monat erstellte/geschlossene Aufgaben",
      en: "Tasks created/closed this month",
      nl: "Deze maand aangemaakte/afgesloten taken",
    },
    openTasks: {
      de: "Offene Aufgaben",
      en: "Open Tasks",
      nl: "Open taken",
    },
    closedTasks: {
      de: "Geschlossene Aufgaben",
      en: "Closed Tasks",
      nl: "Afgesloten taken",
    },
    omApproachTitle: {
      de: "Fälle nach OM-Ansatz",
      en: "Cases according to OM-Approach",
      nl: "Issues volgens OM-aanpak",
    },
    selectedSolutionsTitle: {
      de: "Fälle nach ausgewählter Lösung",
      en: "Cases according to selected solution",
      nl: "Fälle nach ausgewählter Lösung",
    },
    costPerFinalSolTitle: {
      de: "Kosten per Finale Lösungstyp",
      en: "Costs per Final Solution Type",
      nl: "Kosten per Type Definitieve Oplossing",
    },
    contractTitle: {
      de: "Fälle nach Vertrag",
      en: "Cases according to Contract",
      nl: "Issues volgens contract",
    },
    dinCodeRespDepTitle: {
      de: "Fälle nach Zuständige Abt.",
      en: "Cases according to Responsible Dept.",
      nl: "Issues volgens verantwoordelijke afdeling.",
    },
    pcnSourceTitle: {
      de: "Fälle nach PCN Source",
      en: "Cases according to the PCN Source",
      nl: "Issues volgens PCN Source",
    },
    licenseWarningText: {
      de: "Diese Grafik ist nicht in Ihrem Lizenzmodell enthalten. Kontaktieren Sie Ihren Projektmanager für einen Testzugang und weiteren Informationen.",
      en: "This graphic is not included in your license model. Contact your project manager for trial access and further information.",
      nl: "Deze afbeelding is niet inbegrepen in je licentiemodel. Neem contact op met je projectmanager voor proeftoegang en meer informatie.",
    },
    noDataWarningText: {
      de: "Keine Daten zur Anzeige verfügbar",
      en: "No data available to display",
      nl: "Geen gegevens beschikbaar om weer te geven",
    },
    january: {
      de: "Januar",
      en: "January",
    },
    february: {
      de: "Februar",
      en: "February",
    },
    march: {
      de: "März",
      en: "March",
    },
    april: {
      de: "April",
      en: "April",
    },
    may: {
      de: "Mai",
      en: "May",
    },
    june: {
      de: "Juni",
      en: "June",
    },
    july: {
      de: "Juli",
      en: "July",
    },
    august: {
      de: "August",
      en: "August",
    },
    september: {
      de: "September",
      en: "September",
    },
    october: {
      de: "Oktober",
      en: "October",
    },
    november: {
      de: "November",
      en: "November",
    },
    december: {
      de: "Dezember",
      en: "December",
    },
    filterFrom: {
      de: "Wählen Sie Daten aus:",
      en: "Select data from:",
      nl: "Selecteer gegevens van:",
    },
    filterTo: {
      de: "Zu:",
      en: "To:",
      nl: "Naar:",
    },
    filter: { de: "Filter", en: "Filter", nl: "Filter" },
    title: { de: "Statistik", en: "Charts", nl: "Grafieken" },
    unknown: {
      de: "Unbekannt",
      en: "Unknown",
    },
    number: {
      de: "Anzahl",
      en: "Number",
    },
    resetFilter: {
      de: "Filter zurücksetzen",
      en: "Reset filters",
      nl: "Reset filters",
    },
    omFilters: {
      de: "OM filter",
      en: "OM filter",
      nl: "OM filter",
    },
    vehicle: {
      de: "Fälle pro Fahrzeug",
      en: "Cases per Vehicle",
      nl: "Issues per Materieelserie",
    },
    dinCode: {
      de: "Auswirkung nach DIN-Code",
      en: "Impact for each DIN-code",
      nl: "Impact per DIN-code",
    },
    fleet: {
      de: "Auswirkung nach Flotte",
      en: "Impact per fleet",
      nl: "Impact per vloot",
    },
    status: {
      de: "Fälle nach Status",
      en: "Cases according to status",
      nl: "Issues per status",
    },
    department: {
      de: "Fälle pro Abteilung",
      en: "Cases per Department",
      nl: "Issues per afdeling",
    },
    responsible: {
      de: "Fälle pro Verantwortlicher",
      en: "Cases per Responsible",
      nl: "Issues per OM-aanspreekpunt",
    },
    totalCostLTB: {
      de: "LNB Gesamtkosten",
      en: "LNB Total Costs",
    },
    omapproachesCurrentYear: {
      de: "OM-Ansätze (Aktuelles Jahr)",
      en: "OM-Approaches (Current Year)",
      nl: "OM-Benaderingen (Huidig Jaar)",
    },
    omapproachesPerYear: {
      de: "OM-Ansätze (Jährlich)",
      en: "OM-Approaches (Per Year)",
      nl: "OM-Benaderingen",
    },
    solutionsCurrentYear: {
      de: "Ausgewählte Lösungen (Aktuelles Jahr)",
      en: "Selected Solutions (Current Year)",
      nl: "Geselecteerde Afhandelstrategieën (Huidig Jaar)",
    },
    solutionsPerYear: {
      de: "Ausgewählte Lösungen (Gesamt)",
      en: "Selected Solutions (Overall)",
      nl: "Geselecteerde Afhandelstrategieën (Totaal)",
    },
    sortBy_alphabetic: {
      de: "alphabetisch",
      en: "alphabetic",
      nl: "alfabetisch",
    },
    sortBy_impacts: {
      de: "Auswirkungen",
      en: "impacts",
      nl: "Impact",
    },
    sortBy: {
      de: "sortieren nach: ",
      en: "sort by: ",
      nl: "gesorteerd naar: ",
    },
    closed: {
      de: "Geschlossen",
      en: "Closed",
      nl: "Gesloten",
    },
    open: {
      de: "Offen",
      en: "Open",
      nl: "Open",
    },
    others: {
      de: "Sonstige",
      en: "Others",
      nl: "Overige",
    },
    quantity: {
      de: "Anzahl",
      en: "Number",
      nl: "Nummer",
    },
    total: {
      de: "Gesamt",
      en: "Total",
      nl: "Totaal",
    },
    totalUniqueCases: {
      de: "Gesamtzahl der Einzelfälle",
      en: "Total Unique Cases",
      nl: "Totaal unieke gevallen",
    },
    currency: {
      de: "€",
      en: "€",
      nl: "€",
    },
    currencySize: {
      de: "T",
      en: "K",
      nl: "K",
    },
    viewBy: {
      de: "Ansicht von: Status",
      en: "Viewing by: Status",
      nl: "Bekeken door: Status",
    },
  },
  list: {
    charts: [],
    omCharts: [],
    vehicles: [""],
  },
  url: {},
  field: {
    abbreviatedMonths: {
      type: FieldTypes.options,
      text: {
        de: "Abbreviated Months",
        en: "Abbreviated Months",
        nl: "Abbreviated Months",
      },
      options: abbreviatedMonths,
    },
    closedNew: {
      type: FieldTypes.options,
      text: {
        de: "New / Closed cases",
        en: "New / Closed cases",
        nl: "New / Closed cases",
      },
      options: closedNewOptions,
    },
  },
  additionalInfo: {},
};

export const graphs: ComponentSettings<typeof settings> = settings;
